import * as forms from './forms.js';

jQuery(() => {
  // Return-access redirects (processReturnAccessRedirects) live in replay.ts,
  // which is enqueued on every frontend page — not only where the block renders.
  forms.applyDateTypeToDatepickers();
  forms.applyInputMaskingToTelephoneFields();
  forms.applyChangeEventToAutoSubmitSelectFields();
  forms.applyMultiUploadMarkup();
  forms.applyInlineHeroTextPlaceholders();
  forms.relocateConsentBoxesOnInlineHeroForms();
  forms.applyAddressAutocompleteEventListeners();
});

// AJAX re-renders replace the form markup, destroying autocomplete/date/mask setup (#9679)
jQuery(document).on('gform_post_render', () => {
  forms.applyDateTypeToDatepickers();
  forms.applyInputMaskingToTelephoneFields();
  forms.applyChangeEventToAutoSubmitSelectFields();
  forms.applyInlineHeroTextPlaceholders();
  forms.relocateConsentBoxesOnInlineHeroForms();
  forms.applyAddressAutocompleteEventListeners();
});
